import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HomepageBlock1 } from "./HomepageBlock1";
import { HomepageBlock2 } from "./HomepageBlock2";
import { HomepageBlock3 } from "./HomepageBlock3";
import { HomepageBlock4 } from "./HomepageBlock4";
import { HomepageBlock5 } from "./HomepageBlock5";
import { HomepageBlock6 } from "./HomepageBlock6";
import { HomepageBlock7 } from "./HomepageBlock7";
import { HomepageBlock8 } from "./HomepageBlock8";
import { HomepageBlock9 } from "./HomepageBlock9";
import { HomepageBlock10 } from "./HomepageBlock10";

export const homepageBlocks: BlockExportMapping = {
  EvergreenHomepageBlock1: HomepageBlock1,
  EvergreenHomepageBlock2: HomepageBlock2,
  EvergreenHomepageBlock3: HomepageBlock3,
  EvergreenHomepageBlock4: HomepageBlock4,
  EvergreenHomepageBlock5: HomepageBlock5,
  EvergreenHomepageBlock6: HomepageBlock6,
  EvergreenHomepageBlock7: HomepageBlock7,
  EvergreenHomepageBlock8: HomepageBlock8,
  EvergreenHomepageBlock9: HomepageBlock9,
  EvergreenHomepageBlock10: HomepageBlock10,
};
